export const ModalTypes = {
  SHOW: '@modal/SHOW',
}
